import router from '@/router'
import store from '@/store'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { getToken } from '@/utils/auth' // get token from cookie
import Cookies from "@/utils/Cookies";

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/login','/userRegister','/forget'] //  不需要重定向的

router.beforeEach((to, from, next) => {
  // 载入进度条开始
  // NProgress.start()
  document.title= '理菜宝-'+to.meta.title;
  // alert(JSON.stringify(to))
  // 获取token 
  const hasToken = getToken()
  const hasUser = Cookies.get("userInfo")
  const hasShop = Cookies.get("shopInfo")
  if (hasToken && hasUser && hasShop) {
    if (to.path === '/login') {
      // 如果已经登陆，重定向到首页
      next({ path: '/' })
      // NProgress.done() // 载入进度结束
    } else {
      // 设置replace: true，这样导航就不会留下历史记录
      // NProgress.done() // 载入进度结束
      next()
      // next({ ...to, replace: true })
    }
  } else {
    /* 没有token 登录*/
    if (whiteList.indexOf(to.path) > -1) {
      // 如果是不需要登录的页面，不用跳转
      next()
    } else {
      // 记录下来是从哪个页面跳到登录的，登录完成后重新跳回去.
      next(`/login?redirect=${to.path}`)
      // NProgress.done() // 载入进度结束
    }
  }
})

router.afterEach((to, from, next) => {

  // 载入进度结束
  // NProgress.done()
  // next()
})
